import { Middleware } from "@nuxt/types";
import Cookie from "js-cookie";

import { TIMEOUT_REDIRECT } from "@/shared/constants/timeout.constant";

const authChecker: Middleware = (context) => {
  const pathWithoutToken = [
    "/", // Login Page
    "/verify", // Verify Page
    "/forget-password", // Forget Password Page
    "/finish", // IDK
    "/otp", // OTP Page
    "/change-password", // Change Password Page
  ];
  const currentPath = context.route.path;

  // Skip the Auth Checker if the path is public.
  if (
    pathWithoutToken.includes(currentPath) ||
    currentPath.startsWith("/verify")
  ) {
    return;
  }

  // When token empty, show the Snackbar and redirect to login page.
  const token = Cookie.get("t");
  if (!token) {
    const timeoutId = setTimeout(() => {
      clearTimeout(timeoutId);
      context.store.dispatch("app/toggleSnackBar", {
        message: "Sesi Anda telah berakhir.",
        color: "invert-error",
        isNoSidebarToolbar: true,
      });
    }, TIMEOUT_REDIRECT);
    return context.store.dispatch("auth/authDestroy");
  }
};

export default authChecker;
